import { render, staticRenderFns } from "./ModalGlobalIntegrations.vue?vue&type=template&id=06ce5039&scoped=true&"
import script from "./ModalGlobalIntegrations.vue?vue&type=script&lang=js&"
export * from "./ModalGlobalIntegrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ce5039",
  null
  
)

export default component.exports